export const results = (id,result) => ({
  type: 'TRANSACTION_RESULTS',
  id,
  result
})